export default "__VITE_ASSET__U0X6Wg11__"